import type { ComponentProps, FunctionComponent } from 'react';

import { ctw } from '@/common';
import { buttonVariants } from '@/components';

export const BallerineLink: FunctionComponent<
  ComponentProps<'a'> & { disableTranslation?: boolean }
> = ({ className, href, children, disableTranslation = false, ...props }) => {
  return (
    <a
      className={ctw(
        buttonVariants({
          variant: 'link',
        }),
        'notranslate h-[unset] cursor-pointer !p-0 !text-blue-500',
        className,
      )}
      target={'_blank'}
      rel={'noopener noreferrer'}
      href={href}
      translate="no"
      {...props}
    >
      {children}
    </a>
  );
};
